// "09:00" -> "9", "09:30" -> "9:30" — randevu penceresi neredeyse hep tam saatte
// başlayıp bittiği için dakikayı sadece gerektiğinde gösteriyoruz, sütun dar kalsın diye.
export function fmtTimeCompact(hhmm) {
  if (!hhmm) return '-';
  const [h, m] = hhmm.split(':');
  const hNum = parseInt(h, 10);
  return m === '00' ? String(hNum) : `${hNum}:${m}`;
}

export function abbreviateName(name) {
  if (!name) return '-';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length <= 1) return name;
  return `${parts[0]} ${parts[parts.length - 1].charAt(0)}.`;
}

export function fmtMin(v) {
  if (!v) return '0 dk';
  const sign = v > 0 ? '+' : '';
  return `${sign}${Math.round(v)} dk`;
}

export function kmClass(v) {
  if (v < -0.05) return 'km-neg';
  if (v > 0.05) return 'km-pos';
  return 'km-zero';
}

export function fmtKmText(v) {
  if (v == null) return '-';
  const sign = v > 0 ? '+' : '';
  return `${sign}${v.toFixed(1)} km`;
}

// [kod, tam etiket (title/tooltip için), renk sınıfı] — sütun dar olduğundan kısa kod
// gösterilir, tam metin hover'da görünür.
export const STATUS_LABELS = {
  pending: ['BEK', 'Beklemede', 'status-pending'],
  started: ['BAŞ', 'Başlandı', 'status-started'],
  road: ['YOL', 'Yola Çıktı', 'status-road'],
  completed: ['TAM', 'Tamamlandı', 'status-completed'],
  cancelled: ['İPT', 'İptal', 'status-cancelled'],
  notdone: ['YOK', 'Yapılmadı', 'status-cancelled'],
  suspended: ['ASK', 'Askıda', 'status-pending'],
  bucket: ['SIR', 'Sırada', 'status-pending'],
};

export const NON_SELECTABLE_STATUSES = ['completed', 'road', 'started'];

export function statusInfo(statusDescription) {
  const key = (statusDescription || '').trim().toLowerCase();
  const [code, label, cls] = STATUS_LABELS[key] || ['-', statusDescription || '-', 'status-pending'];
  return { code, label, cls };
}

export function isNonMovableStatus(statusDescription) {
  return NON_SELECTABLE_STATUSES.includes((statusDescription || '').trim().toLowerCase());
}
